module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/goto/goto.component.scss
// module id = ./client/app/goto/goto.component.scss
// module chunks = main